module.exports = __webpack_public_path__ + "img/Instagram_icon.b91e455c.png";